import React from "react";
import Dashboard_buckets_card from "../../../../../common_components/dashboard_buckets_card/Dashboard_buckets_card";

function Global_map_buckets() {
  // Data Array
  const bucketData = [
    {
      imgSrc: "/assets/images/portal/global_map/buckets/building.webp",
      number: "25",
      heading_text: "Total Cities",
      text: "Active cities worldwide"
    },
    {
      imgSrc: "/assets/images/portal/global_map/buckets/love_people.webp",
      number: "12",
      heading_text: "Active Users",
      text: "Active user accounts"
    },
    {
      imgSrc: "/assets/images/portal/global_map/buckets/hand_home.webp",
      number: "€800",
      heading_text: "Partner Properties",
      text: "Hotels and properties onboarded"
    },
   
  ];

  return (
    <>
      <section className="Dashboard_buckets Global_map_buckets">
        <div className="heading_text_holder">
          <h2>Global Map</h2>
        </div>

        <div className="row">
          {bucketData.map((item, index) => (
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 mb-3" key={index}>
              <Dashboard_buckets_card
                imgSrc={item.imgSrc}
                number={item.number}
                heading_text={item.heading_text}
                text={item.text}
              />
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default Global_map_buckets;
